module.exports = __webpack_public_path__ + "static/media/area_b_schedule.c2496bc4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/26-27/area_b_schedule.pdf
// module id = 266
// module chunks = 0